<script setup lang="ts">
import { defineProps, defineEmits, watch } from 'vue';

const props = defineProps({
	title: String,
	visible: Boolean,
});

const emit = defineEmits(["close"]);

const closeModal = (e: Event) => {
  e.preventDefault();
  e.stopPropagation();
  emit('close')
};

watch(() => props, (newValue) => {
	if(newValue.visible){
		document.body.style.overflowY = 'hidden';
	} 
	else{
		document.body.style.overflowY = 'auto';
	}
}, { deep: true, immediate: true });
</script>

<template>
	<div class="modal-overlay" v-if="visible">
		<div class="modal-container">
			<header class="modal-header">
				<h2 class="modal-title">{{ props.title }}</h2>
				<button class="close-button bp-icon-Cross" @click="closeModal($event)"></button>
			</header>
			<section class="modal-body">
				<slot></slot>
			</section>
			<footer class="modal-footer">
				<slot name="footer"></slot>
			</footer>
		</div>
	</div>
</template>

<style lang="scss" scoped>
@import "ModalComponent";
</style>
